<template>
    <div class="login-container" :style="{height: scrollerHeight}">
        <div class="form-box" v-if="tabTag==0">
            <el-form ref="loginForm" :model="loginForm" :rules="loginRules" class="login-form" auto-complete="off"
                     label-position="left">
                <div class="title-container">
                    <div class="title">健康大数据分析平台</div>
                </div>
                <div class="login-type">
<!--                    <div class="login-type-btn" :class="{'login-down':loginType==0}"-->
<!--                         @click="loginType=0">密码登录-->
<!--                    </div>-->
<!--                    <div class="login-type-btn login-type-right" :class="{'login-down':loginType==1}"-->
<!--                         @click="loginType=1">验证码登录-->
<!--                    </div>-->
                </div>
                <div v-if="loginType == 0">
                    <el-form-item prop="username">
                        <el-input
                                ref="username"
                                v-model="loginForm.username"
                                placeholder="请输入北斗卫星手表APP账号"
                                name="username"
                                type="text"
                                maxlength="11"
                                tabindex="1"
                                auto-complete="off"
                        >
                            <i slot="prefix" class="login_icon el-input__icon el-icon-user"></i>
                        </el-input>
                    </el-form-item>

                    <el-form-item prop="password">
                        <el-input
                                :key="passwordType"
                                ref="password"
                                v-model="loginForm.password"
                                :type="passwordType"
                                placeholder="请输入密码"
                                name="password"
                                maxlength="20"
                                tabindex="2"
                                auto-complete="off"
                                @keyup.enter.native="handleLogin"
                        >
                            <i v-if="passwordType === 'password'" slot="prefix"
                               class="login_icon el-input__icon el-icon-lock"></i>
                            <i v-if="passwordType != 'password'" slot="prefix"
                               class="login_icon el-input__icon el-icon-unlock"></i>
                            <img v-if="passwordType === 'password'" @click="passwordType=''" slot="suffix"
                                 class="login_icon el-input__icon close-eye" src="@/assets/login/closeEye.png">
                            <i v-if="passwordType != 'password'" @click="passwordType='password'" slot="suffix"
                               class="login_icon el-input__icon el-icon-view"></i>
                        </el-input>
                    </el-form-item>
                </div>
                <div v-if="loginType == 1">
                    <el-form-item prop="username">
                        <el-input
                                ref="username"
                                v-model="loginForm.username"
                                placeholder="请输入北斗卫星手表APP账号"
                                name="username"
                                type="text"
                                oninput="value=value.replace(/[^\d]/g,'')"
                                maxlength="11"
                                tabindex="1"
                                auto-complete="off"
                        >
                            <i slot="prefix" class="login_icon el-input__icon el-icon-user"></i>
                        </el-input>
                    </el-form-item>

                    <el-form-item prop="smsCode">
                        <el-input
                                ref="smsCode"
                                v-model="loginForm.smsCode"
                                placeholder="请输入手机验证码"
                                name="smsCode"
                                maxlength="6"
                                tabindex="2"
                                auto-complete="off"
                                @keyup.enter.native="handleLogin"
                        >
                            <i slot="prefix" class="login_icon el-input__icon el-icon-lock"></i>
                            <el-button v-if="countDown == 0" slot="append"
                                       :class="{'sms-active':loginForm.username.length == 11}"
                                       :disabled="loginForm.username.length != 11" @click="sendSms">获取验证码
                            </el-button>
                            <el-button slot="append" class="sms-active" :disabled="true" v-if="countDown != 0">
                                {{countDown}}s
                            </el-button>
                        </el-input>
                    </el-form-item>
                </div>
                <div class="check-box">
                    <el-checkbox v-model="rememberPass" v-show="loginType == 0">记住密码</el-checkbox>
                    <el-checkbox v-model="agree">我已阅读并同意北斗手表后台系统的<span class="conceal" @click="toConceal">隐私协议</span>
                    </el-checkbox>
<!--                    <div class="forgetPwd" @click="tabTag=1" v-show="loginType == 0">忘记密码?</div>-->
                </div>
                <el-button :loading="loading" class="loginBtn" type="success"
                           @click.native.prevent="handleLogin">登录
                </el-button>

            </el-form>
        </div>
        <div class="form-box reset-box" v-if="tabTag != 0">
            <div class="close-box" @click="tabTag=0">
                <i class="el-icon-circle-close"></i>
            </div>
            <el-form ref="resetForm" :model="resetForm" :rules="loginRules" class="login-form" auto-complete="off"
                     label-position="left" v-if="tabTag == 1">
                <div class="title-container">
                    <div class="title">重置密码</div>
                    <div class="sub-title">（密码要求字符长度6~20位，且至少包含数字、字母和特殊符号中的2种）</div>
                </div>
                <el-form-item prop="username">
                    <el-input
                            ref="username"
                            v-model="resetForm.username"
                            placeholder="请输入北斗卫星手表APP账号"
                            name="username"
                            type="text"
                            oninput="value=value.replace(/[^\d]/g,'')"
                            maxlength="11"
                            tabindex="1"
                            auto-complete="off"
                    >
                    </el-input>
                </el-form-item>
                <el-form-item prop="repassword">
                    <el-input
                            :key="passwordType"
                            v-model="resetForm.repassword"
                            :type="passwordType"
                            placeholder="请输入密码"
                            name="repassword"
                            maxlength="20"
                            tabindex="2"
                            auto-complete="off"
                            @keyup.enter.native="handleLogin"
                    >
                        <img v-if="passwordType === 'password'" @click="passwordType=''" slot="suffix"
                             class="login_icon el-input__icon close-eye" src="@/assets/login/closeEye.png">
                        <i v-if="passwordType != 'password'" @click="passwordType='password'" slot="suffix"
                           class="login_icon el-input__icon el-icon-view"></i>
                    </el-input>
                </el-form-item>
                <el-form-item prop="smsCode">
                    <el-input
                            ref="smsCode"
                            v-model="resetForm.smsCode"
                            placeholder="请输入手机验证码"
                            name="smsCode"
                            maxlength="6"
                            tabindex="2"
                            auto-complete="off"
                    >
                        <el-button v-if="countDown == 0" slot="append"
                                   :class="{'sms-active':loginForm.username.length == 11}"
                                   :disabled="loginForm.username.length != 11" @click="sendSms">获取验证码
                        </el-button>
                        <el-button slot="append" class="sms-active" :disabled="true" v-if="countDown != 0">
                            {{countDown}}s
                        </el-button>
                    </el-input>
                </el-form-item>
                <el-button :loading="loading" class="loginBtn" type="success"
                           @click.native.prevent="resetPwd">提交
                </el-button>

            </el-form>
            <div class="reset-success-box" v-if="tabTag == 2">
                <div class="success-icon">
                    <i class="el-icon-success"></i>
                </div>
                <div class="success-title">密码重设成功！</div>
                <div class="login-down-box"><span class="login-down">{{toLoginDown}}s</span>后返回登录页</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Login',
        data() {
            const validatePassword = (rule, value, callback) => {
                let reg = /((?=.*\d)(?=.*\D)|(?=.*[a-zA-Z])(?=.*[^a-zA-Z]))(?!^.*[\u4E00-\u9FA5].*$)/
                if (value === '' || value.length < 6 || value.length > 20) {
                    callback(new Error('请输入6-20位密码'))
                } else if (!reg.test(value)) {
                    callback(new Error('需包含数字、字母和特殊符号中的2种'))
                } else {
                    callback()
                }
            }
            return {
                tabTag: 0,
                resetForm: {
                    username: '',
                    repassword: '',
                    smsCode: ''
                },
                loginType: 0,
                loginForm: {
                    username: '',
                    password: '',
                    smsCode: '',
                },
                loginRules: {
                    username: [{required: true, trigger: 'blur', message: '请输入11位手机号', max: 11}],
                    password: [{required: true, trigger: 'blur', message: '请输入6-20位密码', max: 20, min: 6}],
                    smsCode: [{required: true, trigger: 'blur', message: '请输入6位验证码'}],
                    repassword: [{required: true, trigger: 'blur', validator: validatePassword}]
                },
                loading: false,
                passwordType: 'password',
                redirect: undefined,
                rememberPass: false,
                agree: false,
                countDown: 0, // 验证码倒计时
                toLoginDown: 0, // 密码重置成功倒计时
            }
        },
        watch: {
            $route: {
                handler: function (route) {
                    this.redirect = route.query && route.query.redirect
                },
                immediate: true
            }
        },
        mounted() {
            console.log(111)
            this.rememberPass = localStorage.getItem("rememberPass") == 'true' ? true : false;
            this.agree = localStorage.getItem("agree") == 'true' ? true : false;
            if (this.rememberPass) {
                this.loginForm.username = localStorage.getItem("phone");
                this.loginForm.password = localStorage.getItem("pwd");
            } else {
                this.loginForm.username = '';
                this.loginForm.password = '';
            }
        },
        computed: {
            // 滚动区高度
            scrollerHeight: function () {
                return (window.innerHeight) + 'px'; //自定义高度需求
            }
        },
        methods: {
            showPwd() {
                if (this.passwordType === 'password') {
                    this.passwordType = ''
                } else {
                    this.passwordType = 'password'
                }
                this.$nextTick(() => {
                    this.$refs.password.focus()
                })
            },
            handleLogin() {
                if (!this.agree) {
                    this.$message({
                        message: '请先阅读并勾选隐私协议',
                        type: 'error'
                    });
                } else {
                    this.$refs.loginForm.validate(valid => {
                        if (valid) {
                            this.loading = true
                            this.loginForm.loginType = this.loginType;
                            this.$store.dispatch('user/login', this.loginForm).then(() => {
                                // if (this.loginForm.username == 'prodprod') {
                                //   this.redirect = 'resource/prodDown'
                                // } else {
                                //   this.redirect = 'resource/dashboard'
                                // }
                                if (this.loginType == 0) {
                                    localStorage.setItem("phone", this.loginForm.username);
                                    localStorage.setItem("pwd", this.loginForm.password);
                                    localStorage.setItem("rememberPass", this.rememberPass);
                                    localStorage.setItem("agree", this.agree);
                                }
                                this.$router.push({path: '/home'})
                                this.loading = false
                            }).catch(() => {
                                this.loading = false
                            })
                        } else {
                            console.log('error submit!!')
                            return false
                        }
                    })
                }

            },
            // 去隐私政策页
            toConceal() {
                window.open('https://service.beidouwatch.com/bdwatch_web/view/privacy.html', "_blank");
            },
            // 发送验证码请求
            sendSms() {
                const that = this
                this.$api.user.dispatch({
                    phone: this.loginForm.username
                }).then(response => {
                    if (response.result == 1) {
                        that.countDown = 60
                        const interval = window.setInterval(function () {
                            if ((that.countDown--) <= 0) {
                                that.countDown = 0
                                window.clearInterval(interval)
                            }
                        }, 1000)
                    }
                })
            },
            // 重置密码
            resetPwd() {
                let that = this;
                this.$refs.resetForm.validate(valid => {
                    if (valid) {
                        this.$api.user.updatePassword({
                            newPwd: this.resetForm.repassword,
                            phone: this.resetForm.username,
                            smsCode: this.resetForm.smsCode
                        }).then(response => {
                            if (response.result == 1) {
                                this.$message({
                                    message: '密码重设成功！',
                                    type: 'success'
                                });
                                this.tabTag = 2;
                                that.toLoginDown = 3;
                                const interval = window.setInterval(function () {
                                    if ((that.toLoginDown--) <= 0) {
                                        that.toLoginDown = 0;
                                        that.tabTag = 0;
                                        window.clearInterval(interval)
                                    }
                                }, 1000)
                            }
                        })
                    } else {
                        console.log('error submit!!')
                        return false
                    }
                })
            },
        }
    }
</script>

<style scoped>
    .login-container {
        width: 100%;
        height: 100%;
        background: url("~@/assets/login/bg.png") #11161E;
        background-size: cover;
        box-sizing: border-box;
        overflow: hidden;
    }

    .form-box {
        font-size: 16px;
        width: 400px;
        margin: 200px auto 0;
        background-color: #ffffff;
        border-radius: 12px;
        border: 1px solid #C7C7C7;
        padding: 30px 40px;
    }

    .title-container {
        text-align: center;
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 500;
        color: #545454;
        margin-bottom: 20px;
    }

    .login_icon {
        font-size: 24px !important;
        width: 30px;
    }

    /deep/ .el-input__inner {
        padding-left: 40px !important;
    }

    /deep/ .el-input__inner:focus {
        border-color: #20D38F;
    }

    .conceal {
        color: #20D38F;
    }

    /deep/ .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #20D38F;
        border-color: #20D38F;
    }

    /deep/ .el-checkbox__input.is-checked + .el-checkbox__label {
        color: #444444;
    }

    /deep/ .el-checkbox {
        color: #444444;
        height: 25px;
    }

    .loginBtn {
        background-color: #20D38F;
        width: 100%;
        margin: 10px 0 10px 0;
        border-color: #20D38F;
    }

    .check-box {
        position: relative;
        height: 83px;
    }

    .forgetPwd {
        position: absolute;
        top: 0;
        right: 0px;
        color: #20D38F;
        text-decoration: underline;
        font-size: 14px;
        cursor: pointer;
    }

    .sms-active {
        color: #20D38F !important;
        width: 112px;
    }

    .sub-title {
        color: #BBBBBB;
        font-size: 12px;
        text-align: center;
        margin-top: 5px;
    }

    .reset-box {
        position: relative;
    }

    .close-box {
        position: absolute;
        font-size: 36px;
        color: #ffffff;
        right: -80px;
        top: -80px;
        cursor: pointer;
    }

    .reset-success-box {
        height: 326px;
        text-align: center;
    }

    .success-icon {
        font-size: 100px;
        color: #20D38F;
        padding: 30px 0;
    }

    .success-title {
        font-size: 18px;
    }

    .login-down-box {
        font-size: 14px;
        color: #C7C7C7;
        margin-top: 20px;
    }

    .login-down {
        color: #20D38F !important;
    }

    .login-type {
        text-align: center;
        margin-bottom: 20px;
    }

    .login-type-btn {
        display: inline-block;
        width: 40%;
        color: #BBBBBB;
        font-size: 18px;
        cursor: pointer;
    }

    .login-type-left {
        border-right: 1px solid #BBBBBB;
    }
</style>



// WEBPACK FOOTER //
// src/views/login/index.vue